import { Link } from "react-router-dom";
import { articles, getCategory } from "@/mocks/content";

const picks = ["a4", "a2"];

export default function DeepDive() {
  const list = picks.map((id) => articles.find((a) => a.id === id)!).filter(Boolean);

  return (
    <section className="border-y border-background-300/60 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex items-center gap-3">
          <span className="flex h-8 items-center rounded-md bg-accent-500 px-3 text-xs font-bold text-background-50">
            深度复盘
          </span>
          <div className="ornate-line h-px flex-1" />
          <span className="text-xs tracking-widest text-foreground-500">只挑值得慢读的两篇</span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {list.map((a, idx) => {
            const cat = getCategory(a!.category);
            const flip = idx % 2 === 1;
            return (
              <article
                key={a!.id}
                className="group grid grid-cols-1 overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200/70 transition-all hover:-translate-y-1 hover:ring-primary-300 md:grid-cols-2"
              >
                <div className={`h-48 w-full overflow-hidden md:h-full ${flip ? "md:order-2" : ""}`}>
                  <img
                    src={a!.wideCover ?? a!.cover}
                    alt={a!.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col p-6 md:p-7">
                  <span className={`self-start rounded-full px-3 py-1 text-xs font-medium text-background-50 ${cat.dot}`}>
                    {cat.name}
                  </span>
                  <h3 className="mt-3 font-display text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                    <Link to={`/article/${a!.slug}`} className="group-hover:text-primary-600">
                      {a!.title}
                    </Link>
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                    {a!.summary}
                  </p>
                  <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                    <span>
                      {a!.author} · {a!.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" aria-hidden="true" /> {a!.readMin} 分钟
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}